/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useParams } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PageHeader from '../../layouts/page-header/PageHeader';
import { useTranslation } from 'react-i18next';
import { getSingleCompetition } from '../../store/actions';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import BlogSidebar from './sidebar';
import moment from 'moment/moment';
import '../blog/blog.scss';
import { formatMonth } from '../../data/format-month';
import { base } from '../../store/api';
import replaceWithSpace from '../../data/replace';
import Loading from '../../component/Loading';
import { HiOutlineEye } from 'react-icons/hi2';

function BlogSingle() {
  let { id } = useParams();
  const { t } = useTranslation();
  const [data, setData] = useState({});
  const dispatch = useDispatch();
  const language = localStorage.getItem('i18nextLng');
  const [loading, setLoading] = useState(true);

  const formatDate = (date) => {
    const month = date?.split('T')[0].split('-')[1];
    return `${formatMonth(month, language)} ${moment(date).format(
      `DD, YYYY HH:MM`
    )}`;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const lang = language === 'tm' ? 'tk' : language;
    setLoading(true);
    getSingleCompetition(dispatch, id, lang, (err, res) => {
      if (err) console.log(err);
      setData(res?.data);
      setLoading(false);
    });
  }, [language, id]);

  return (
    <>
      <div className="tw-w-full tw-mt-60">
        <PageHeader
          colSize="col-md-10"
          title={t('competitions')}
          PagaHeaderBg={'/images/bg.svg'}
          breadCrumbItems={[{ label: t('home'), path: '/' }]}
        />
        <div className="content-wrapper page-template">
          <Container>
            <Row className="justify-content-center">
              {loading ? (
                <div className="tw-w-full tw-flex tw-flex-row tw-justify-center tw-items-center">
                  <Loading style={{ width: '10%' }} />
                </div>
              ) : (
                <Col xl={8} lg={12}>
                  <article className="about-post blog-post">
                    <div className="entry-content">
                      <div className="entry-meta">
                        <ul>
                          <li key="meta-category">
                            <img
                              src="/images/calendar.svg"
                              className=""
                              alt="calendar"
                            />
                          </li>
                          <li key="meta-date" className="">
                            <div className="tw-flex tw-flex-row tw-items-center tw-gap-x-1">
                              {Object.keys(data).length && <div>{formatDate(data.start_date)}</div> }
                              <div className="tw-w-8" />
                              <HiOutlineEye size={22} className="tw-size-4"/>
                              <span>{data.view_count ? data.view_count : 0}</span>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <h4 className="entry-title pt-2">
                        {Object.keys(data).length ? data.title : ''}
                      </h4>
                    </div>
                    <div className="tw-w-full tw-aspect-[3/2]">
                      {data?.image && (
                        <img
                          className="tw-w-full tw-aspect-[3/2] tw-object-contain"
                          src={
                            Object.keys(data).length
                              ? `${base}${data.image}`
                              : ''
                          }
                          width={600}
                          height={400}
                          alt=""
                        />
                      )  }
                    </div>
                    <div className="entry-content tw-max-w-screen tw-overflow-x-auto">
                      <div className="">
                        {Object.keys(data).length && (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: replaceWithSpace(data.content),
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </article>
                </Col>
              )}
              {loading ? null : (
                <Col className="tw-w-full" xl={4} md={12}>
                  <BlogSidebar news_id={id} />
                </Col>
              )}
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}

export default BlogSingle;
